export const generateDateOptions = (slots) => {
    const WeekChars = ['(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)'];
    const disable = [
        new Date(2024, 11, 24).toDateString(),
        new Date(2024, 11, 25).toDateString(),
        new Date(2024, 11, 26).toDateString(),
        new Date(2024, 11, 29).toDateString(),
        new Date(2024, 11, 30).toDateString(),
        new Date(2024, 11, 31).toDateString(),
        new Date(2025, 0, 1).toDateString(),
        new Date(2025, 0, 2).toDateString(),
        new Date(2025, 0, 3).toDateString(),
        new Date(2025, 0, 4).toDateString(),
    ];

    const dates = [];

    for (let i = 4; i <= 40; i++) {
        const d1 = new Date();
        d1.setDate(d1.getDate() + i);

        const validation = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate()).toDateString();

        if (!disable.includes(validation)) {
            const day = d1.getDay(); // 0: Sun, 1: Mon, ..., 6: Sat
            const dayKey = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][day];
            if (slots[dayKey] && slots[dayKey].length > 0) {
                const labelDateOption = `${d1.getMonth() + 1}月${d1.getDate()}日 ${WeekChars[day]}`;
                const valueDateOption = `${d1.getFullYear()}/${(d1.getMonth() + 1).toString().padStart(2, '0')}/${d1.getDate().toString().padStart(2, '0')}`;
                dates.push({ value: valueDateOption, label: labelDateOption });
            }
        }
    }

    return { dates };
};

export const handleDateChange = (date, setTimeOptions, slots) => {
    const timeOptions = [];
    const selectedDate = new Date(date);
    const day = selectedDate.getDay();
    const dayKey = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][day];

    if (slots[dayKey] && slots[dayKey].length > 0) {
        slots[dayKey].forEach(slot => {
            // slot は "hh:mm~hh:mm" 形式なので、そのまま使用する
            timeOptions.push({ value: slot, label: slot });
        });
    }

    setTimeOptions(timeOptions);
};

